import { get_token, getCookie, csrf_headers } from "@/router";
import { build_incident_type_form_data } from "@/views/manage_incident/manage_incident_helper";
import Swal from "sweetalert2";
import {append_active_organization_id, } from "@/utils/organization_profile";

function is_successful_data_response(response) {
  return response?.status === "success" && Boolean(response?.data);
}
function normalize_updated_type(data, incident_type_id, existing_type) {
  const { entity_type_name, ...updated_data } = data;
  return {
    ...existing_type,
    ...updated_data,
    id: updated_data.id || incident_type_id,
    name: entity_type_name,
  };
}
function show_updated_type_message(response) {
  $("#incidentTypeModal").one("hidden.bs.modal", () => {
    Swal.fire({
      icon: "success",
      title: "Updated!",
      text: response.message || "Incident type updated successfully.",
      timer: 2000,
      showConfirmButton: false,
      position: "bottom-end",
      toast: true,
    });
  });
}
function show_delete_error(message) {
  Swal.fire({
    icon: "error",
    title: "Unable to delete",
    text: message,
    position: "bottom-end",
    toast: true,
    timer: 3000,
    showConfirmButton: false,
  });
}
function show_deleted_type_message(response, type) {
  Swal.fire({
    icon: "success",
    title: "Deleted!",
    text: response.message || `${type.name} was deleted successfully.`,
    timer: 1500,
    showConfirmButton: false,
    position: "bottom-end",
    toast: true,
  });
}
function get_incident_type_authority_ids(incident_type) {
  const direct_ids =incident_type.assigned_admin_ids;
  return direct_ids;
}

function normalize_incident_type({ entity_type_name, ...incident_type }) {
  return {
    ...incident_type,
    name: entity_type_name,
    icon: incident_type.icon || "bi-exclamation-triangle-fill",
    color: incident_type.color || "#6c757d",
    authority_ids: get_incident_type_authority_ids(incident_type),
  };
}
function get_assignment_changes(selected_ids, original_ids) {
  const selected_admin_ids = selected_ids.map(Number);
  const original_admin_ids = original_ids.map(Number);
  return {
    selected_admin_ids,
    admin_ids: selected_admin_ids.filter((id) => !original_admin_ids.includes(id)),
    unassign_admin_ids: original_admin_ids.filter((id) => !selected_admin_ids.includes(id)),
  };
}
function show_assignment_error(message) {
  Swal.fire({
    icon: "error",
    title: "Unable to assign",
    text: message,
    position: "bottom-end",
    toast: true,
    timer: 3000,
    showConfirmButton: false,
  });
}
function show_assignment_success(response) {
  $("#assignAuthorityModal").one("hidden.bs.modal", () => {
    Swal.fire({
      icon: "success",
      title: "Assigned!",
      text: response.message || "Incident type assignments updated successfully.",
      timer: 1500,
      showConfirmButton: false,
      position: "bottom-end",
      toast: true,
    });
  });
}
const manage_incident_type_api = {
    build_request_headers(token, include_content_type = false) {
        const headers = Object.assign(
            { Authorization: `Token ${token}` },
            csrf_headers(getCookie("csrftoken")),
        );
        if (include_content_type) Reflect.set(headers, "Content-Type", "application/json");
        return headers;
    },
    create_incident_type() {
        return $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/create_incident_type/`,
          type: "POST",
          data: build_incident_type_form_data(this.type_form),
          processData: false,
          contentType: false,
          xhrFields: { withCredentials: true },
          headers: this.build_request_headers(get_token()),
          beforeSend: () => (this.saving_incident_type = true),
          success: (response) => {
            if (response?.status !== "success" || !response?.data) return;
            if (typeof this.handle_create_incident_type_success === "function") {
              this.handle_create_incident_type_success(response);
              return;
            }

            const { entity_type_name, ...created_data } = response.data;
            const created_type = {
              ...created_data,
              name: entity_type_name,
            };

            this.destroy_incident_types_datatable();
            this.incident_types.unshift(created_type);
            $("#incidentTypeModal").one("hidden.bs.modal", () => {
              Swal.fire({
                icon: "success",
                title: "Created!",
                text: response.message || "Incident type created successfully.",
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-end",
                toast: true,
              });
            });
            this.close_type_form();
            this.refresh_incident_types_datatable();
          },
          error: (xhr) => {
            if (typeof this.handle_create_incident_type_error === "function") {
              this.handle_create_incident_type_error(xhr);
              return;
            }
            this.incident_error = xhr.responseJSON?.message || "Unable to create the incident type.";
          },
          complete: () => (this.saving_incident_type = false),
        });
      },
    edit_incident_type() {
        const incident_type_id = this.editing_type_id;
        return $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/edit_incident_type/`,
          type: "POST",
          data: build_incident_type_form_data(this.type_form, { incident_type_id }),
          processData: false,
          contentType: false,
          xhrFields: { withCredentials: true },
          headers: this.build_request_headers(get_token()),
          beforeSend: () => (this.saving_incident_type = true),
          success: (response) => this.handle_edit_incident_type_success(response, incident_type_id),
          error: (xhr) => {
            this.incident_error = xhr.responseJSON?.message || "Unable to edit the incident type.";
          },
          complete: () => (this.saving_incident_type = false),
        });
      },
    handle_edit_incident_type_success(response, incident_type_id) {
        if (!is_successful_data_response(response)) return;
        const type_index = this.incident_types.findIndex((type) => type.id === incident_type_id);
        const existing_type = Reflect.get(this.incident_types, type_index);
        const updated_type = normalize_updated_type(response.data, incident_type_id, existing_type);
        this.destroy_incident_types_datatable();
        if (type_index !== -1) this.incident_types.splice(type_index, 1, updated_type);
        show_updated_type_message(response);
        this.close_type_form();
        this.refresh_incident_types_datatable();
      },
    delete_incident_type(type) {
        return $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/delete_incident_type/`,
          type: "POST",
          data: JSON.stringify(append_active_organization_id({
            incident_type_id: type.id,
          })),
          xhrFields: { withCredentials: true },
          headers: this.build_request_headers(get_token(), true),
          beforeSend: () => (this.deleting_incident_type_id = type.id),
          success: (response) => this.handle_delete_incident_type_success(response, type),
          error: (xhr) => this.handle_delete_incident_type_error(xhr),
          complete: () => (this.deleting_incident_type_id = null),
        });
    },
    handle_delete_incident_type_success(response, type) {
        if (response?.status !== "success") {
          show_delete_error(response?.message || "The incident type could not be deleted.");
          return;
        }

        this.destroy_incident_types_datatable();
        this.incident_types = this.incident_types.filter((incident_type) => incident_type.id !== type.id);
        this.refresh_incident_types_datatable();
        show_deleted_type_message(response, type);
      },
    handle_delete_incident_type_error(xhr) {
        show_delete_error(xhr.responseJSON?.message || "Unable to delete the incident type.");
      },
    get_incident_types_by_scope(){
        return $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/get_incident_types_by_scope/`,
            type: "POST",
            data: JSON.stringify(append_active_organization_id({})),
            xhrFields: { withCredentials: true },
            headers: this.build_request_headers(get_token(), true),
            beforeSend: () => (this.loading_incident_types = true),
            success: (response) => {
                if (response?.status !== "success" || !Array.isArray(response?.data)) return;

                this.destroy_incident_types_datatable();
                this.incident_types = response.data.map(normalize_incident_type);
            },
            error: (xhr) => {
                this.incident_error = xhr.responseJSON?.message || "Unable to get the incident types.";
            },
            complete: () => {
                this.loading_incident_types = false;
                this.$nextTick(() => {
                    $("#incidentTypeModal")
                        .off("hidden.bs.modal.manageIncidentType")
                        .on("hidden.bs.modal.manageIncidentType", this.reset_type_form);
                    this.init_incident_types_datatable();
                });
            },
        });
    },
    get_organization_admins() {
        $.ajax({
          url: this.get_incident_admins_url(),
          type: "GET",
          xhrFields: { withCredentials: true },
          headers: this.build_request_headers(get_token(), true),
          success: (response) => {
            if (!this.loading_incident_types) this.destroy_incident_types_datatable();
            this.admins = Array.isArray(response?.data) ? response.data : [];
            if (!this.loading_incident_types) this.refresh_incident_types_datatable();
          },
          error: (xhr) => {
            this.incident_error = xhr.responseJSON?.message || "Unable to load incident admins.";
          },
        });
      },
    get_incident_admins_url() {
        const endpoint = this.client_features?.show_organisation
          ? "get_organization_admins"
          : "get_system_admins";
        return `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/${endpoint}/`;
      },
    assign_incident_type_to_admin(incident_type_id) {
        const changes = get_assignment_changes(
          this.selected_authority_ids,
          this.original_authority_ids,
        );
        return $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/assign_incident_type_admin/`,
          type: "POST",
          data: JSON.stringify(append_active_organization_id({
            incident_type_id,
            admin_ids: changes.admin_ids,
            unassign_admin_ids: changes.unassign_admin_ids,
          })),
          xhrFields: { withCredentials: true },
          headers: this.build_request_headers(get_token(), true),
          beforeSend: () => (this.assigning_incident_type_id = incident_type_id),
          success: (response) => this.handle_assignment_success(response, incident_type_id, changes.selected_admin_ids),
          error: (xhr) => this.handle_assignment_error(xhr),
          complete: () => (this.assigning_incident_type_id = null),
        });
      },
    handle_assignment_success(response, incident_type_id, selected_admin_ids) {
        if (response?.status !== "success") {
          show_assignment_error(response?.message || "The incident type could not be assigned.");
          return;
        }

        this.destroy_incident_types_datatable();
        const incident_type = this.incident_types.find((type) => String(type.id) === String(incident_type_id));
        if (incident_type) incident_type.authority_ids = [...selected_admin_ids];
        this.refresh_incident_types_datatable();
        show_assignment_success(response);
        this.close_assign_modal();
      },
    handle_assignment_error(xhr) {
        show_assignment_error(xhr.responseJSON?.message || "Unable to assign the incident type.");
      },
}

export default manage_incident_type_api;
